import { ColumnsType } from 'antd/lib/table'
import { TUserCreditsBySubscription } from '../../../../../context/types'

const columns: (units: string) => ColumnsType<TUserCreditsBySubscription> = (units: string) => [
	{
		title: units,
		dataIndex: 'availableAmount',
		key: 'availableAmount',
		width: '30%',
		align: 'center',
	},
	{
		title: 'Expiration Date',
		dataIndex: 'expirationDate',
		key: 'expirationDate',
		width: '70%',
		align: 'center',
	},
]

export { columns }
